import { QueryState } from '@/common/enum';
import { Nullable } from 'interfaces/Nullable.ts';

export type TeamsStateTypes = {
  queryState: QueryState;
  error: Nullable<string>;
};

export const TeamsInitialState: TeamsStateTypes = {
  queryState: QueryState.UNDEFINED,
  error: null,
};
